export default __webpack_public_path__ + "static/media/energy_saver.0ccccb7c.jpeg";